/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 1232
// module chunks = 0